import axios from '@/libs/api.request'

/**
 * 导出用户工作监控
 */
export const exportUserMonitor = (org_id, username, realname) => {
    let data = {
        'org_id': org_id,
        'username': username,
        'realname': realname
    }
    return axios.request({
        url: '/api/admin/usermonitor/export',
        data,
        method: 'post'
    })
}

/**
 * 导出用户工作监控日志
 */
export const exportUserMonitorLog = (user_id, date_begin, date_end) => {
    let data = {
        'user_id': user_id,
        'date_begin': date_begin,
        'date_end': date_end
    }
    return axios.request({
        url: '/api/admin/usermonitorlog/export',
        data,
        method: 'post'
    })
}
